export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-[color:var(--page-fg)]">
      <main className="max-w-[58rem] mx-auto px-4 sm:px-6 pt-28 pb-16 md:pt-32">
        <div className="rounded-[28px] border border-[color:rgba(2,127,219,0.12)] bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(247,250,255,0.98),rgba(255,255,255,0.985))] backdrop-blur-xl shadow-[0_24px_70px_rgba(2,127,219,0.08),0_10px_26px_rgba(15,23,42,0.04)] p-6 sm:p-8 lg:p-12">
          <h1 className="text-3xl md:text-4xl lg:text-[3.1rem] font-semibold mb-8 text-[color:var(--page-fg)] leading-tight tracking-[-0.02em]">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-lg max-w-none prose-headings:text-[color:var(--page-fg)] prose-p:text-[color:var(--page-fg)] prose-li:text-[color:var(--page-fg)] prose-strong:text-[color:var(--page-fg)] prose-a:text-[var(--brand-blue)] prose-a:underline hover:prose-a:no-underline prose-p:leading-[1.75] prose-li:leading-[1.7]">
            <h2 className="text-2xl font-semibold mb-4 mt-8">1. Verantwortliche Stelle</h2>
            <p className="mb-4">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist die Alltagsstern UG (haftungsbeschränkt), vertreten durch den Geschäftsführer Furkan Yildiz, Wischmattenweg 14a, 12357 Berlin. Kontakt: <a href="mailto:info@alltagsstern.com">info@alltagsstern.com</a>
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">2. Allgemeine Hinweise zur Datenverarbeitung</h2>
            <p className="mb-4">
              Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der geltenden gesetzlichen Vorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).
            </p>
            <p className="mb-4">
              Personenbezogene Daten werden nur erhoben, wenn dies technisch erforderlich ist oder wenn Sie uns diese Daten freiwillig im Rahmen einer Kontaktaufnahme oder Bewerbung übermitteln.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">3. Hosting</h2>
            <p className="mb-4">
              Diese Website wird über den Hosting-Dienstleister Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA, bereitgestellt. Beim Aufruf der Website können technisch notwendige Verbindungsdaten verarbeitet werden, insbesondere IP-Adresse, Browsertyp, Gerätetyp, Datum und Uhrzeit des Zugriffs sowie angeforderte Dateien.
            </p>
            <p className="mb-4">
              Die Verarbeitung erfolgt zur sicheren, stabilen und technisch fehlerfreien Bereitstellung der Website auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
            </p>
            <p className="mb-4">
              Sofern eine Verarbeitung in Drittländern erfolgt, erfolgt diese auf Grundlage geeigneter Garantien, insbesondere der EU-Standardvertragsklauseln des Anbieters. Server- und Sicherheitsprotokolle werden nur so lange gespeichert, wie dies für Betrieb, Sicherheit und Fehleranalyse erforderlich ist.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">4. Kontaktaufnahme</h2>
            <p className="mb-4">
              Wenn Sie uns per Kontaktformular, E-Mail oder telefonisch kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten ausschließlich zur Bearbeitung Ihrer Anfrage und zur Kommunikation im Rahmen Ihres Anliegens.
            </p>
            <p className="mb-4">
              Dies betrifft insbesondere Angaben wie Name, Telefonnummer, E-Mail-Adresse, gewünschte Unterstützung, Pflegegrad sowie den Inhalt Ihrer Nachricht. Die Angabe des Pflegegrads ist freiwillig und hilft uns, die Anfrage fachlich einzuordnen.
            </p>
            <p className="mb-4">
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Kommunikation) bzw. Art. 6 Abs. 1 lit. f DSGVO.
            </p>
            <p className="mb-4">
              Kontaktformular-Anfragen werden per E-Mail an Alltagsstern UG (haftungsbeschränkt) übermittelt. Dabei können die von Ihnen angegebenen Daten sowie technisch erforderliche Verbindungsdaten wie die IP-Adresse verarbeitet werden. Die Daten werden gelöscht, sobald die Anfrage abschließend bearbeitet wurde, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">5. Bewerbungen</h2>
            <p className="mb-4">
              Wenn Sie uns im Rahmen einer Bewerbung personenbezogene Daten übermitteln, verarbeiten wir diese ausschließlich zur Durchführung des Bewerbungsverfahrens.
            </p>
            <p className="mb-4">
              Die Verarbeitung erfolgt auf Grundlage von § 26 BDSG sowie Art. 6 Abs. 1 lit. b DSGVO, soweit dies für die Entscheidung über die Begründung eines Beschäftigungsverhältnisses erforderlich ist.
            </p>
            <p className="mb-4">
              Ihre Bewerbungsdaten werden nur so lange gespeichert, wie dies für die Bearbeitung Ihrer Bewerbung erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">6. Cookies und Tracking</h2>
            <p className="mb-4">
              Diese Website verwendet derzeit keine Analyse-, Marketing- oder Tracking-Cookies. Es werden keine Tracking- oder Marketingdienste ohne Ihre ausdrückliche Einwilligung geladen.
            </p>
            <p className="mb-4">
              Soweit technisch notwendige Speicherungen oder Browserfunktionen verwendet werden, dienen diese ausschließlich dem sicheren und funktionalen Betrieb der Website. Ein Cookie-Banner wird derzeit nicht eingesetzt, weil keine einwilligungspflichtigen Cookies oder vergleichbaren Tracking-Technologien geladen werden.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">7. Speicherdauer</h2>
            <p className="mb-4">
              Personenbezogene Daten werden nur so lange gespeichert, wie dies für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">8. Ihre Rechte</h2>
            <p className="mb-4">
              Sie haben das Recht auf Auskunft über die bei uns gespeicherten personenbezogenen Daten sowie auf Berichtigung, Löschung, Einschränkung der Verarbeitung und Widerspruch gegen die Verarbeitung im gesetzlichen Rahmen.
            </p>
            <p className="mb-4">
              Zudem haben Sie das Recht, sich bei einer zuständigen Datenschutzaufsichtsbehörde zu beschweren.
            </p>
            <p className="mb-4">
              Zur Ausübung Ihrer Rechte können Sie sich jederzeit über die im Impressum angegebenen Kontaktdaten oder direkt per E-Mail an <a href="mailto:info@alltagsstern.com">info@alltagsstern.com</a> wenden.
            </p>

            <div className="mt-12 pt-8 border-t border-[color:rgba(2,127,219,0.14)]">
              <p className="text-sm opacity-70 text-[color:var(--page-fg)]">Stand: April 2026</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
